import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={11} fill="none" ref={ref} {...props}>
    <g stroke={props?.stroke || '#383838'} strokeLinejoin="round">
      <path
        fill="#fff"
        d="m1.053 7.864 2.821-5.76c.523-1.066 2.043-1.066 2.566 0l2.82 5.76c.124.252.223.535-.03.736-1.182.943-6.964.943-8.147 0-.252-.201-.154-.481-.03-.736Z"
      />
      <path strokeLinecap="round" d="M5.156 3.95v1.785m0 1.607v.179" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconWarning = memo(ForwardRef);
export default IconWarning;
